import { z } from 'zod';
import { errorMap } from 'zod-validation-error';

import { localeCodes } from '@flywire/internal-components/utils/translations';

import { errorMessageForColorVariable, isValidRGBColor } from './colorUtils';
import { errorMessageForLengthVariable, isValidCssLength } from './fontSizeUtils';
import { isSameOriginUrl } from './urlUtils';

const FontSchema = z.object({
  url: z.string().url().refine(isSameOriginUrl, {
    message:
      'Non-allowed url for font. Only the same origin and https://fonts.googleapis.com are allowed.'
  }),
  fontFamily: z.string()
});

const VariablesSchema = z
  .object({
    primaryColor: z
      .string()
      .optional()
      .refine(isValidRGBColor, {
        message: errorMessageForColorVariable('primaryColor')
      }),
    headerFontSize: z
      .string()
      .optional()
      .refine(isValidCssLength, {
        message: errorMessageForLengthVariable('headerFontSize')
      })
  })
  .optional();

const AppearanceSchema = z.object({
  fonts: z.array(FontSchema).optional(),
  variables: VariablesSchema.optional()
});

const ElementsOptionsSchema = z
  .object({
    appearance: AppearanceSchema.optional(),
    locale: z.enum(localeCodes).optional()
  })
  .optional();

export const parseSDKOptions = (data: unknown) =>
  ElementsOptionsSchema.safeParse(data, { errorMap: errorMap });
